import profileImg from "../images/profile2.png";
import aboutMedia from "../images/about-img.jpg";
import projectImg1 from "../images/about-img.jpg";
import projectImg2 from "../images/about-img.jpg";
import award1 from "../images/about-img.jpg";
import award2 from "../images/about-img.jpg";
import award3 from "../images/about-img.jpg";

export const SERVICE_ID = 'service_aklaew3';
export const TEMPLETE_ID = 'template_hd0i4wg';
export const PUBLIC_KEY = 'LVxzyY5I_EJehnAnq';


export const menuItems = [
    {
        id: 1,
        title: "Home",
        url: "#profile"
    },
    {
        id: 2,
        title: "About me",
        url: "#about"
    },
    {
        id: 3,
        title: "Skills",
        url: "#skill"
    },
    {
        id: 4,
        title: "Projects",
        url: "#projects"
    },
    {
        id: 5,
        title: "Awards",
        url: "#awards"
    },
    {
        id: 6,
        title: "contact",
        url: "#contact"
    }
];


export const ProfileData = {
    profileName: 'Jitendra Sharma',
    profile_image: profileImg,
    profile_image_alt: 'alt text here',
    profile_desc: `<p>Hi, I’m Jitendra. I’m currently pursuing a Master of Science in Electrical and Computer Engineering at Southern Illinois University Edwardsville. I have over a year of experience in web development and more than six months of experience in grid operation and maintenance.</p>`,
    socialData: {
        socialHeading: 'Follow with us:-',
        socialLink1: '/',
        socialLink2: '/',
    },
    buttons: {
        button_1_title: 'Hire me',
        button_1_url: '/',
        button_2_title: 'Contact me',
        button_2_url: '/',
    }

}

export const aboutData = {
    block_title:'About me',
    about_media: aboutMedia,
    about_media_alt: 'alt text here',
    about_desc:`<p>My name is Jitendra Sharma, pursuing a Master’s in Electrical and Computer Engineering at SIUE. I have extensive experience in web development and electrical engineering, having worked at SmartSites Nepal and Nepal Electricity Authority. Skilled in MATLAB, Simulink, Power World Simulator, and various web platforms, I also hold leadership roles in student organizations.</p>`,
    download_cv_btn_url:'/',
    download_cv_btn_title:'Download cv',
}
export const educationData = [
    {
        tab1 : 'education',
        tab2 : 'ecxprience',
    }
]

export const projectData = [
    {
        projectTitle: ' Smart Irrigation and Surveillance',
        projectDesc: `<p>The project was designed and simulated on Proteus. Also programming board (Arduino) was embedded to 
        enhance farming, collecting field data to predict optimal crop cultivation methods for maximum production 
        efficiency and cost-effectiveness.
        </p>`,   
        projectImage1: projectImg1,
        projectImage2: projectImg2,
        button: {
            title: 'View project',
            url: '/'
        }
    },
    {
        projectTitle: '  Smart Irrigation and Surveillance',
        projectDesc: `<p>Four solar panels were installed, tracking the sun for efficiency. A waste management system alerts officials of container status. Solar power lights streets at night. Plans are underway to connect to the grid for energy supply
        </p>`,   
        projectImage1: projectImg1,
        projectImage2: projectImg2,
        button: {
            title: 'View project',
            url: '/'
        }
    },
    {
        projectTitle: '   Application of Internet of Things',
        projectDesc: `<p>The workshop was about practical uses of internet-connected devices. I learn how IoT enhances efficiency, 
        automation, and data collection across various fields
        </p>`,   
        projectImage1: projectImg1,
        projectImage2: projectImg2,
        button: {
            title: 'View project',
            url: '/'
        }
    },
    {
        projectTitle: '  Embedded AI in IoT Devices',
        projectDesc: `<p>The workshop on embedded AI was about integrating artificial intelligence into devices. I learn to create 
        smart systems capable of autonomous decision-making, enhancing efficiency and functionality in various 
        applications.
        </p>`,   
        projectImage1: projectImg1,
        projectImage2: projectImg2,
        button: {
            title: 'View project',
            url: '/'
        }
    },
    {
        projectTitle: ' Robotics',
        projectDesc: `<p>The robotics workshop was to design, build, and program robots. I learn about sensors, actuators, and 
        programming languages to create autonomous machines for various tasks and industries
        </p>`,   
        projectImage1: projectImg1,
        projectImage2: projectImg2,
        button: {
            title: 'View project',
            url: '/'
        }
    }
]

export const awardContent = [
    {
        as_award_media_rep: [
            {
                as_images: award1
            },
            {
                as_images: award2
            },
            {
                as_images: award3
            }
        ],
        as_award__description: 'As Vice President of the Nepalese Student Association (NSA) at SIUE, I spearheaded cultural and advocacy  efforts to empower and unite Nepalese students on campus. I organized events.',
        as_award_button: {
            title: 'View All',
            url: '#'
        }
    }
]